import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useNavigate } from '@web/Router/router.hooks';
import { useGetConversation } from '@web/conversations/hooks/useGetConversation';

import { ConversationEditForm } from './ConversationEditForm';

export const ConversationEdit = () => {
  const { id } = useParams();
  const conversationId = +id;
  const {
    data: conversation,
    isLoading,
    isPlaceholderData,
  } = useGetConversation({
    id: conversationId,
  });
  const isConversationReady = !(isLoading || isPlaceholderData);
  const navigate = useNavigate();

  // editing private conversations is not allowed
  useEffect(() => {
    if (isConversationReady && conversation.isPrivate) {
      navigate.toConversationDetails({
        params: { id: conversation.id, slug: conversation.slug },
      });
    }
  }, [isConversationReady, conversation, navigate]);

  return isConversationReady ? <ConversationEditForm conversation={conversation} /> : null;
};
